export default function SectionHeading({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) {
  return (
    <div className="flex flex-col gap-y-0.5">
      <h2 className="text-lg-bold">{title}</h2>
      <p className="text-sm-medium text-black-500">{subtitle}</p>
    </div>
  );
}
